// AUTO-GENERATED from src/data/comparisons.ts — compact index for RelatedComparisons.
// Keeps the 99KB comparison bank out of the critical bundle.
export type ComparisonCard = {
  slug: string; titleTh: string; titleEn: string;
  descTh: string; descEn: string; altLabelTh: string; altLabelEn: string;
};

export const COMPARISON_CARDS: ComparisonCard[] = [
  {
    "slug": "nyc-vs-freelance-translator",
    "titleTh": "NYC vs นักแปลฟรีแลนซ์ — เลือกแบบไหนดี?",
    "titleEn": "NYC vs Freelance Translator — Which Is Better?",
    "descTh": "เปรียบเทียบบริษัทแปลเอกสาร NYC กับนักแปลฟรีแลนซ์ ครบทุกมิติ: ราคา ความเร็ว การรับรองสถานทูต ความเสี่ยง การประกัน",
    "descEn": "Compare NYC Legal & Notary vs freelance translators across price, speed, embassy acceptance, risk, and insurance.",
    "altLabelTh": "นักแปลฟรีแลนซ์",
    "altLabelEn": "Freelance Translator"
  },
  {
    "slug": "nyc-vs-google-translate",
    "titleTh": "NYC vs Google Translate — แปลเอกสารราชการได้จริงหรือ?",
    "titleEn": "NYC vs Google Translate — Can AI Translate Official Documents?",
    "descTh": "เปรียบเทียบ NYC Legal & Notary กับการใช้ Google Translate / ChatGPT แปลเอกสารราชการ — สถานทูตและกรมการกงสุลยอมรับหรือไม่?",
    "descEn": "Compare NYC vs Google Translate / ChatGPT for official documents — do embassies and government offices accept AI translations?",
    "altLabelTh": "Google Translate / AI",
    "altLabelEn": "Google Translate / AI"
  },
  {
    "slug": "nyc-vs-translation-app",
    "titleTh": "NYC vs แอปแปลภาษา (DeepL, Naver Papago) — งานราชการใช้ได้ไหม?",
    "titleEn": "NYC vs Translation Apps (DeepL, Papago) — Acceptable for Official Use?",
    "descTh": "DeepL, Papago, Microsoft Translator แปลเอกสารราชการได้ไหม? เปรียบเทียบกับนักแปลรับรองของ NYC",
    "descEn": "Can DeepL, Papago, or Microsoft Translator handle official documents? Compared with NYC certified translators.",
    "altLabelTh": "DeepL / Papago / MS Translator",
    "altLabelEn": "DeepL / Papago / MS Translator"
  },
  {
    "slug": "nyc-vs-chatgpt",
    "titleTh": "NYC vs ChatGPT/Claude — ใช้ AI แปลเอกสารราชการได้ไหม?",
    "titleEn": "NYC vs ChatGPT/Claude — Can AI Translate Official Documents?",
    "descTh": "เปิดประเด็น: ปี 2026 AI แปลเก่งมาก แต่ทำไมยังต้องใช้บริษัทแปล? คำตอบอยู่ที่ Notary Seal และความรับผิดทางกฎหมาย",
    "descEn": "In 2026 AI translates fluently — so why still hire an agency? Answer: Notary Seal and legal liability.",
    "altLabelTh": "ChatGPT / Claude / AI",
    "altLabelEn": "ChatGPT / Claude / AI"
  },
  {
    "slug": "nyc-vs-diy-translation",
    "titleTh": "NYC vs แปลเอง (DIY) — ความเสี่ยงที่ต้องรู้ก่อนยื่นเอกสาร",
    "titleEn": "NYC vs DIY Translation — Hidden Risks Before You Submit",
    "descTh": "เปรียบเทียบแปลเอกสารเองกับใช้บริษัทแปลรับรอง: ต้นทุนแฝง โอกาสถูกปฏิเสธ ระยะเวลาที่เสียไปกับการแก้",
    "descEn": "Compare DIY translation vs certified agency: hidden costs, rejection risk, time wasted on rework.",
    "altLabelTh": "แปลเอง (DIY)",
    "altLabelEn": "DIY Translation"
  },
  {
    "slug": "nyc-vs-fiverr-translation",
    "titleTh": "NYC vs Fiverr/Upwork — แปลเอกสารราชการได้ไหม?",
    "titleEn": "NYC vs Fiverr/Upwork — Can Marketplaces Handle Official Docs?",
    "descTh": "ทำไม Fiverr/Upwork ไม่เหมาะสำหรับเอกสารยื่นสถานทูต MFA หรือศาล: ขาด Notary, ขาดประกัน, ไม่มี VAT",
    "descEn": "Why Fiverr/Upwork are unsuitable for embassy/MFA/court documents: no Notary, no insurance, no VAT receipt.",
    "altLabelTh": "Fiverr / Upwork",
    "altLabelEn": "Fiverr / Upwork"
  },
  {
    "slug": "nyc-vs-court-translator",
    "titleTh": "NYC vs นักแปลศาล — ใช้แทนกันได้ไหม?",
    "titleEn": "NYC vs Court-Appointed Translator — Are They Interchangeable?",
    "descTh": "เปรียบเทียบบริการแปลของ NYC กับนักแปลศาล (ล่ามศาล) สำหรับคดีแพ่ง อาญา ครอบครัว และ MOJ",
    "descEn": "Compare NYC translation services vs court-appointed translators for civil, criminal, family, and MOJ cases.",
    "altLabelTh": "นักแปลศาล",
    "altLabelEn": "Court-Appointed Translator"
  },
  {
    "slug": "nyc-vs-naati-overseas",
    "titleTh": "NYC NAATI (ไทย) vs NAATI ออสเตรเลีย — ราคาและเวลา",
    "titleEn": "NYC NAATI (Thailand) vs Australia NAATI — Price & Time",
    "descTh": "ใช้บริการ NAATI แปลในประเทศไทยกับ NYC vs ส่งเอกสารไปแปลที่ออสเตรเลีย — เปรียบเทียบราคา เวลา ค่าส่ง",
    "descEn": "Compare using NYC's Thailand-based NAATI translators vs shipping documents to Australia — price, time, shipping.",
    "altLabelTh": "NAATI ออสเตรเลีย",
    "altLabelEn": "Australia-based NAATI"
  },
  {
    "slug": "nyc-vs-thai-embassy-translation",
    "titleTh": "NYC vs สถานทูตไทยในต่างประเทศ — แปลที่ไหนดีกว่า?",
    "titleEn": "NYC vs Royal Thai Embassy Translation — Where to Translate?",
    "descTh": "เปรียบเทียบการแปลเอกสารผ่าน NYC ในไทย vs ส่งให้สถานทูตไทยในต่างประเทศแปลให้ — ราคา ความเร็ว และการยอมรับ",
    "descEn": "Compare translating via NYC in Thailand vs sending to a Royal Thai Embassy abroad — price, speed, acceptance.",
    "altLabelTh": "สถานทูตไทยในต่างประเทศ",
    "altLabelEn": "Royal Thai Embassy Abroad"
  },
  {
    "slug": "nyc-vs-online-translator",
    "titleTh": "NYC vs เว็บแปลออนไลน์ราคาถูก — ของจริงหรือกับดัก?",
    "titleEn": "NYC vs Cheap Online Translation Sites — Real Service or Trap?",
    "descTh": "เว็บแปลออนไลน์ราคาเริ่ม ฿99 จริงไหม? เปรียบเทียบกับ NYC ในมุม Notary, MFA, ความปลอดภัยข้อมูล, การรับประกัน",
    "descEn": "Are 99 THB online translation sites real? Compare with NYC on Notary, MFA, data security, and guarantees.",
    "altLabelTh": "เว็บแปลออนไลน์ราคาถูก",
    "altLabelEn": "Cheap Online Translation"
  },
  {
    "slug": "nyc-vs-shipping-document-overseas",
    "titleTh": "NYC vs ส่งเอกสารกลับประเทศบ้านเพื่อแปล/รับรอง",
    "titleEn": "NYC vs Shipping Documents Home for Translation/Legalization",
    "descTh": "ฝรั่งในไทยส่งเอกสารกลับประเทศบ้านเพื่อแปล vs ใช้ NYC แปลในไทย — เปรียบเทียบเวลา ค่าส่ง และความเสี่ยงเอกสารหาย",
    "descEn": "Foreigners in Thailand shipping documents home for translation vs using NYC locally — compare time, courier cost, loss risk.",
    "altLabelTh": "ส่งกลับประเทศบ้าน",
    "altLabelEn": "Ship Home"
  },
  {
    "slug": "nyc-vs-other-law-firms",
    "titleTh": "NYC vs สำนักงานทนายอื่น — ทำไมเลือก NYC?",
    "titleEn": "NYC vs Other Law Firms — Why Choose NYC?",
    "descTh": "เปรียบเทียบ NYC Legal & Notary กับสำนักงานทนายทั่วไปในกรุงเทพ — จำนวน Notary ราคา ความเชี่ยวชาญสถานทูต และ Coverage 353 จุดทั่วไทย",
    "descEn": "Compare NYC vs typical Bangkok law firms — Notary count, pricing, embassy expertise, and 353-location nationwide coverage.",
    "altLabelTh": "สำนักงานทนายทั่วไป",
    "altLabelEn": "Typical Law Firm"
  },
  {
    "slug": "nyc-vs-online-notary",
    "titleTh": "NYC (Notary in-person) vs Remote Online Notary — ใช้ในไทยได้ไหม?",
    "titleEn": "NYC In-person Notary vs Remote Online Notary — Valid in Thailand?",
    "descTh": "Remote Online Notary (RON) ของอเมริกาใช้ในประเทศไทยและสถานทูตได้ไหม? เปรียบเทียบกับ Notary Public Attorney แบบ in-person ของ NYC",
    "descEn": "Can US Remote Online Notary (RON) be used in Thailand and embassies? Compared with NYC's in-person Notary Public Attorney service.",
    "altLabelTh": "Remote Online Notary (RON)",
    "altLabelEn": "Remote Online Notary (RON)"
  },
  {
    "slug": "nyc-vs-thai-lawyer-firm-bangkok",
    "titleTh": "NYC vs สำนักงานทนายความทั่วไปในกรุงเทพ",
    "titleEn": "NYC vs General Bangkok Law Firm",
    "descTh": "ทนายความทั่วไปรับทุกคดี vs NYC เชี่ยวชาญเฉพาะ Notary แปลรับรอง วีซ่า — ใครเหมาะกับงานเอกสารต่างประเทศมากกว่า?",
    "descEn": "General law firms cover everything vs NYC specialized in Notary + translation + visa — which fits cross-border documents better?",
    "altLabelTh": "สำนักงานทนายทั่วไป",
    "altLabelEn": "General Law Firm"
  },
  {
    "slug": "nyc-vs-blockchain-notary",
    "titleTh": "NYC vs Blockchain / Digital Notary (Notarize.com, DocuSign)",
    "titleEn": "NYC vs Blockchain / Online Digital Notary",
    "descTh": "Notary ดิจิทัล (Notarize.com / DocuSign Notary / Blockchain) ใช้ในไทยได้ไหม? สถานทูตและศาลไทยรับรองหรือไม่?",
    "descEn": "Do digital notaries (Notarize.com / DocuSign Notary / Blockchain) work in Thailand? Do Thai embassies and courts accept them?",
    "altLabelTh": "Digital / Blockchain Notary",
    "altLabelEn": "Digital / Blockchain Notary"
  },
  {
    "slug": "nyc-vs-mfa-direct",
    "titleTh": "NYC vs ไปกรมการกงสุล MFA เอง — แบบไหนเร็วกว่า?",
    "titleEn": "NYC vs Going to MFA Yourself — Which Is Faster?",
    "descTh": "เปรียบเทียบใช้ NYC รับรอง MFA Thailand ให้ vs ไปกรมการกงสุลแจ้งวัฒนะเอง — เวลา ค่าใช้จ่าย คิว",
    "descEn": "Compare NYC handling MFA legalization vs DIY at Chaeng Watthana — time, cost, queues.",
    "altLabelTh": "ไป MFA แจ้งวัฒนะเอง",
    "altLabelEn": "DIY at Chaeng Watthana MFA"
  },
  {
    "slug": "nyc-vs-embassy-direct",
    "titleTh": "NYC vs ไปสถานทูตเอง — ประหยัดเวลาแบบไหน?",
    "titleEn": "NYC vs Going to Embassy Yourself — Which Saves More Time?",
    "descTh": "เปรียบเทียบใช้ NYC ดำเนินการรับรองสถานทูตให้ vs ไปยื่นเอง — เวลา ค่าใช้จ่าย ความเสี่ยงเอกสารถูกปฏิเสธ",
    "descEn": "Compare NYC handling embassy legalization vs DIY — time, cost, document rejection risk.",
    "altLabelTh": "ทำเอง (DIY)",
    "altLabelEn": "DIY"
  },
  {
    "slug": "nyc-vs-document-courier",
    "titleTh": "NYC vs บริการรับ-ส่งเอกสารราชการ — ต่างกันอย่างไร?",
    "titleEn": "NYC vs Document Courier Service — What's the Difference?",
    "descTh": "บริการรับ-ส่งเอกสารราชการ (messenger) แค่วิ่งส่ง vs NYC ที่แปล รับรอง และยื่นครบจบในที่เดียว",
    "descEn": "Plain messenger services just transport documents — NYC translates, certifies, AND files end-to-end.",
    "altLabelTh": "บริการรับ-ส่งเอกสาร (Messenger)",
    "altLabelEn": "Document Courier / Messenger"
  },
  {
    "slug": "nyc-vs-immigration-agency",
    "titleTh": "NYC vs เอเจนซี่วีซ่า — ต่างกันยังไง คุ้มไหม?",
    "titleEn": "NYC vs Immigration Agency — Differences and Value",
    "descTh": "เปรียบเทียบบริษัทกฎหมาย NYC (มีทนายรับรอง) กับเอเจนซี่วีซ่าทั่วไป: ความรับผิด การรับประกัน ราคา และอัตราผ่าน",
    "descEn": "Compare NYC (licensed law firm) vs general visa agencies: liability, guarantees, pricing, and approval rates.",
    "altLabelTh": "เอเจนซี่วีซ่า",
    "altLabelEn": "Visa Agency"
  },
  {
    "slug": "nyc-vs-immigration-lawyer-overseas",
    "titleTh": "NYC vs ทนายตรวจคนเข้าเมืองในต่างประเทศ — สำหรับวีซ่าไทย",
    "titleEn": "NYC vs Overseas Immigration Lawyer — for Thai Visa",
    "descTh": "ยื่นวีซ่าไทยจากต่างประเทศ ควรใช้ทนายต่างชาติหรือบริษัทไทย? เปรียบเทียบความเข้าใจกฎหมายไทย ราคา และอัตราอนุมัติ",
    "descEn": "Applying for Thai visa from abroad — use a local immigration lawyer or a Thai firm? Compare local-law expertise, price, approval rate.",
    "altLabelTh": "ทนายตรวจคนเข้าเมืองต่างประเทศ",
    "altLabelEn": "Overseas Immigration Lawyer"
  },
  {
    "slug": "nyc-vs-vfs-global",
    "titleTh": "NYC vs VFS Global — ใช้บริการตัวไหนยื่นวีซ่า?",
    "titleEn": "NYC vs VFS Global — Which to Use for Visa Submission?",
    "descTh": "VFS Global เป็น outsource ของสถานทูต รับยื่นเอกสาร. NYC ช่วยเตรียม แปล รับรอง ก่อนยื่นที่ VFS หรือสถานทูตโดยตรง",
    "descEn": "VFS Global is the embassy's outsource for visa intake. NYC prepares + translates + certifies documents BEFORE you submit at VFS or directly.",
    "altLabelTh": "VFS Global",
    "altLabelEn": "VFS Global"
  },
  {
    "slug": "nyc-vs-bts-visa-agent",
    "titleTh": "NYC vs Agent วีซ่าใกล้สถานทูต — เลือกใครดี?",
    "titleEn": "NYC vs Walk-in Visa Agent near Embassy — Which to Choose?",
    "descTh": "ร้านเอเจนต์วีซ่าใกล้สถานทูต/สำนักตรวจคนเข้าเมือง ราคาถูก แต่ไม่มีทนาย ไม่มีประกัน — เปรียบเทียบความเสี่ยง",
    "descEn": "Walk-in visa shops near embassies offer cheap fees but no lawyers, no insurance — compare the risk profile.",
    "altLabelTh": "Agent วีซ่าใกล้สถานทูต",
    "altLabelEn": "Walk-in Visa Agent"
  },
  {
    "slug": "nyc-vs-thai-language-school-ed-visa",
    "titleTh": "NYC vs โรงเรียนสอนภาษาไทย — สำหรับ ED Visa",
    "titleEn": "NYC vs Thai Language School — for ED Visa",
    "descTh": "โรงเรียนสอนภาษาไทยทำ ED Visa ให้ vs ทนายช่วยเลือกโรงเรียน + ยื่น ED Visa — ต่างกันอย่างไร?",
    "descEn": "Language schools handle ED Visa themselves vs a lawyer who screens schools + files the ED Visa — how do they differ?",
    "altLabelTh": "โรงเรียนสอนภาษาไทย",
    "altLabelEn": "Thai Language School"
  },
  {
    "slug": "nyc-vs-marriage-registration-amphoe",
    "titleTh": "NYC vs จดทะเบียนสมรสที่อำเภอเอง — ต่างชาติ × ไทย",
    "titleEn": "NYC vs DIY Marriage Registration at Amphoe — Foreigner × Thai",
    "descTh": "ฝรั่งจดทะเบียนสมรสกับคนไทย ไปอำเภอเองได้ไหม? เทียบกับใช้ NYC แปล รับรอง และพาไป",
    "descEn": "Can a foreigner register marriage at Amphoe alone? Compare DIY vs NYC-assisted with translation + certification.",
    "altLabelTh": "ไปอำเภอเอง (DIY)",
    "altLabelEn": "DIY at Amphoe"
  }
];

